import { useMutation } from "@tanstack/react-query";
import { bulkUpdateFaqGroups } from "../api/bulkUpdateFaqGroups";
import { deleteFaqGroup } from "../api/deleteFaqGroup";
import {
  getFaqGroupsQueryData,
  setFaqGroupsQueryData,
  invalidateFaqGroupsQuery,
} from "../queries/useFaqGroupsQuery";
import { FaqGroup } from "../types";

export const useDeleteFaqGroupMutation = (faqGroupId?: string) => {
  return useMutation({
    mutationFn: async ({
      faqGroupId,
      faqGroups,
    }: {
      faqGroupId?: string;
      faqGroups: FaqGroup[];
    }) => {
      const updatedFaqGroups = faqGroups.filter(({ id }) => id !== faqGroupId);
      const updatedFaqGroupsWithOrder = updatedFaqGroups.map(
        (faqGroup, index) => ({
          id: faqGroup.id,
          order: index + 1,
        }),
      );

      const previousData = getFaqGroupsQueryData();

      setFaqGroupsQueryData(updatedFaqGroups);

      await Promise.all([
        deleteFaqGroup(faqGroupId),
        bulkUpdateFaqGroups(updatedFaqGroupsWithOrder),
      ]);

      return previousData;
    },
    onSettled: () => {
      if (!faqGroupId) {
        return;
      }
      invalidateFaqGroupsQuery();
    },
    onError: (e) => {
      console.error("Error occurred when deleting faq group", e);
    },
  });
};
